import { Container, Header } from "components/Page"

import { AuthorizedRoute } from "components/AuthorizedRoute"
import Breadcrumbs from "components/Breadcrumbs"
import Button from "ui/buttons/Button"
import CreateAgency from "./CreateModal"
import MarketAgencies from "./Details/List"
import Surface from "components/Surface"
import { css } from "@emotion/css"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"
import { useToggle } from "hooks/useToggle"

function AgenciesMarket() {
  const { t } = useI18n()
  const { open, onOpen, onClose } = useToggle()
  const { hasAuthority } = useAuthenticated()

  return (
    <Container>
      <Breadcrumbs
        section={t("nav.admin")}
        current={t("nav.market.agencies")}
      />
      <Header label={t("nav.market.agencies")}>
        {hasAuthority(["AUTH_CREATE_AGENCY"]) && (
          <>
            <Button variant="contained" color="primary" onClick={onOpen}>
              {` + ${t("market-agency.create.button")}`}
            </Button>
            <CreateAgency open={open} onClose={onClose} />
          </>
        )}
      </Header>
      <div>
        <AuthorizedRoute allowed={["AUTH_VIEW_AGENCY"]}>
          <Surface className={styles.surface}>
            <MarketAgencies newAgency={onOpen} />
          </Surface>
        </AuthorizedRoute>
      </div>
    </Container>
  )
}

const styles = {
  surface: css`
    padding: var(--spacing-xxl-2) var(--spacing-m) var(--spacing-m);
  `,
}
export default AgenciesMarket
